import { createFileRoute } from '@tanstack/react-router'
import { Textos } from '@/features/textos/Textos'

/**
 * Textos da terapeuta: roteiro, estabilização, convites do pré-atendimento e
 * declaração. Mudar a redação aqui não pede deploy.
 */
export const Route = createFileRoute('/_app/app/config/textos')({ component: Textos })
